import React from "react";
import LazyLoading from "../../components/Orders/LazyLoading";
import close from "../assets/cancel.svg";
import { amountFormat } from "../config/helper";

const Table = (props) => {
  const { scroll, totalRecords, data } = props;
  return (
    <div
      className={props.noMargin ? "" : "m2"}
      style={
        props.style
          ? {
              overflowX: "auto",
              ...props.style,
            }
          : {
              overflowX: "auto",
            }
      }
    >
      <div
        className="table"
        id="table"
        style={scroll?.x ? { width: scroll?.x } : undefined}
      >
        <div className="thead">
          <div className="tr">
            {props.columns?.map((ele) => {
              return (
                <div className="td" style={{ width: ele.width + "%" }}>
                  {ele.header}
                </div>
              );
            })}
            {props.action && (
              <div
                className="action-th"
                style={{ width: props.actionWidth + "%" }}
              >
                Action
              </div>
            )}
          </div>
        </div>
        <div className={`tbody ${props.showTotal ? "last-none" : ""}`}>
          {data && data.length > 0 ? (
            data?.map((item) => (
              <div
                className={`tr ${
                  typeof props.onRowClick === "function" ? "clickable" : ""
                }`}
                onClick={() => {
                  if (props.onRowClick) {
                    props.onRowClick(item);
                  }
                }}
              >
                {props.columns.map((ele, i) => {
                  return (
                    <div
                      className={`td ${ele.className ? ele.className : ""} ${
                        props.isCancel ? "flex-between" : ""
                      }`}
                      style={{ width: ele.width + "%" }}
                    >
                      {ele.cell ? ele.cell(item) : item?.[ele?.accessor]}
                      {props.isCancel && i === props.columns.length - 1 && (
                        <img
                          className="cancel"
                          src={close}
                          alt={"close"}
                          width={14}
                          onClick={() => props.delete(item.id)}
                        />
                      )}
                    </div>
                  );
                })}
              </div>
            ))
          ) : props.loading ? null : (
            <div className="no-data">
              No Records Found {props.noDataMsg ? `, ${props.noDataMsg}` : ""}
            </div>
          )}
          <LazyLoading
            loading={props.loading && !data?.length}
            totalRecords={totalRecords}
            isLastPage={props.isLastPage}
            onPagination={props.onPagination}
            data={data}
          />
        </div>
        {props.showTotal && (
          <div className="total m1">
            <div className="w30 d-flex mt1">
              <div className="w40">
                <span className="dim-text">
                  Total Quantity : {props.totalQuantity}
                </span>
              </div>
              <div className="w60">
                <span className="flex-between ml2 mr2">
                  <span className="dim-text">Sub Total :</span>
                  <span> ${amountFormat(props.totalPrice)}</span>
                </span>
                <hr />
                <span className="flex-between ml2 mr2">
                  <span>Total :</span>
                  <span> ${amountFormat(props.totalPrice)}</span>
                </span>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Table;
